import { useState, useEffect } from 'react';

export function Disclaimer() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show disclaimer on every visit (no persistence)
    setVisible(true);
  }, []);

  if (!visible) return null;

  return (
    <div className="disclaimer__overlay">
      <div className="disclaimer__box">
        <div className="disclaimer__header">
          <div className="disclaimer__icon">⚖</div>
          <h2 className="disclaimer__title">Legal Disclaimer</h2>
          <p className="disclaimer__subtitle">
            Prabhu Mallya &amp; Associates — Chartered Accountants
          </p>
        </div>

        <div className="disclaimer__body">
          <p className="disclaimer__intro">
            The Chartered Accountants Act, 1949 prohibits solicitation of work.
            By clicking the <strong>"I Agree"</strong> button below, you acknowledge that:
          </p>
          <ol className="disclaimer__list">
            <li>
              You have accessed this website to gain more information about us.
            </li>
            <li>
              There is no advertisement, personal communication, solicitation,
              invitation, or inducement of any sort whatsoever from us to solicit
              any work through this website.
            </li>
            <li>
              The information about us is provided to you on your specific
              "pull" request.
            </li>
	    <li>
	  	The information provided on this website is made available at your request for
		informational purposes only and should not be interpreted as soliciting or
		advertising.
	    </li>			
          </ol>
        </div>

        <button
          className="disclaimer__btn"
          onClick={() => setVisible(false)}
        >
          I Agree
        </button>
      </div>
    </div>
  );
}
